// extracted by mini-css-extract-plugin
var _1 = "Switch_switch";
export { _1 as "switch" }
